export default "__VITE_ASSET__D1CXUD8k__"